"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1597],{

/***/ 27115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MainMenuTest": function() { return /* binding */ MainMenuTest; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33227);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88361);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92191);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85971);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52715);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91193);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24812);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(23493);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(40483);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8996);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(24036);
/* harmony import */ var _Label_Label__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(44291);
/* harmony import */ var _adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(71357);
/* harmony import */ var react_slide_toggle__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(5021);
/* harmony import */ var react_slide_toggle__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(react_slide_toggle__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(51926);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(47322);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(85893);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



















var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_15___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 80713));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80713)];
    }
  }
});
var Image = next_dynamic__WEBPACK_IMPORTED_MODULE_15___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 48084));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48084)];
    }
  }
});




var MainMenu = /*#__PURE__*/function (_Component) {
  _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_4___default()(MainMenu, _Component);

  var _super = _createSuper(MainMenu);

  function MainMenu(props) {
    var _this;

    _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1___default()(this, MainMenu);

    _this = _super.call(this, props);
    _this._closedSubNavState = '';
    _this._desktopBreakpoint = '(max-width: 991px)';
    _this.handleResizeThrottled = lodash_throttle__WEBPACK_IMPORTED_MODULE_16___default()(_this.handleResize.bind(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3___default()(_this)), 100);
    _this.handleScrollThrottled = lodash_throttle__WEBPACK_IMPORTED_MODULE_16___default()(_this.handleScroll.bind(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3___default()(_this)), 100);
    _this.block = new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z(props);
    _this.insideMenuRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14__.createRef();
    _this.subMenuRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14__.createRef();
    _this.mobileMenuRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14__.createRef();
    _this.openMobileMenuRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14__.createRef();
    _this.innerMenuRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14__.createRef();
    _this.primaryColor = _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.primaryColor */ .o5.primaryColor;
    _this.state = {
      isMainMenuOpen: false,
      currentSubNav: _this._closedSubNavState,
      intervalId: 0,
      lastScroll: 0,
      pathName: '',
      isPageLoaded: false,
      isLoadSubNav: false
    };
    _this.handleToggleSubNavigation = _this.handleToggleSubNavigation.bind(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3___default()(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3___default()(_this));
    _this.handleToggleMainMenu = _this.handleToggleMainMenu.bind(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3___default()(_this));
    _this.handleMenuHeight = _this.handleMenuHeight.bind(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3___default()(_this));
    _this.toggleScroll = _this.toggleScroll.bind(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3___default()(_this));
    _this.handleEscKeyPress = _this.handleEscKeyPress.bind(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3___default()(_this));
    _this.handleStickybar = _this.handleStickybar.bind(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_3___default()(_this));
    _this.firstLink = null;
    _this.lastLink = null;
    return _this;
  }

  _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2___default()(MainMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.mousedown */ .o5.mousedown, this.handleClickOutside);
      window.addEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.resize */ .o5.resize, this.handleResizeThrottled);
      window.addEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.scroll */ .o5.scroll, this.handleScrollThrottled);
      window.addEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.keydown */ .o5.keydown, this.handleEscKeyPress);
      this.setState({
        pathName: window.location.pathname
      });
      this.handleScroll();
      this.handleResize();
      this.handleStickybar();
      this.setState({
        isPageLoaded: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.mousedown */ .o5.mousedown, this.handleClickOutside);
      window.removeEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.resize */ .o5.resize, this.handleResizeThrottled);
      window.removeEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.scroll */ .o5.scroll, this.handleScrollThrottled);
      window.removeEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.keydown */ .o5.keydown, this.handleEscKeyPress);

      if (this.lastLink) {
        this.lastLink.removeEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.blur */ .o5.blur, this.handleMobileLastItemBlur);
      }
    }
  }, {
    key: "handleStickybar",
    value: function handleStickybar() {
      var announcementEle = document.querySelector('.ob-announcement-bar');
      var mainEle = document.getElementById('main');
      announcementEle ? mainEle.classList.remove('ob-main-layout-align') : mainEle.classList.add('ob-main-layout-align');
      mainEle.classList.remove('ob-main-layout-align-padding');
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this$openMobileMenuR,
          _this2 = this;

      if (((_this$openMobileMenuR = this.openMobileMenuRef) == null ? void 0 : _this$openMobileMenuR.current) && this.state.isMainMenuOpen) {
        this.openMobileMenuRef.current.onToggle();
      }

      this.setState({
        currentSubNav: this._closedSubNavState,
        isMainMenuOpen: false
      }, function () {
        _this2.toggleScroll();
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      if (!document.body.classList.contains('noScroll')) {
        this.setState({
          lastScroll: window.pageYOffset
        });
      }
    }
  }, {
    key: "handleEscKeyPress",
    value: function handleEscKeyPress(event) {
      if (event.key === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.escape */ .o5.escape) {
        this.setState({
          currentSubNav: this._closedSubNavState
        }, this.handleAfterEscKeyPress);
      }
    }
  }, {
    key: "handleAfterEscKeyPress",
    value: function handleAfterEscKeyPress() {
      this.toggleScroll();
      this.addBlurListenerOnLastLink();
    }
  }, {
    key: "addBlurListenerOnLastLink",
    value: function addBlurListenerOnLastLink() {
      var mobileMenu = document.querySelector('.ob-main-menu--mobile');

      if (mobileMenu) {
        var links = mobileMenu.getElementsByTagName('a');

        if ((links == null ? void 0 : links.length) > 0) {
          this.firstLink = links[0];
          this.lastLink = links[links.length - 1];
          this.lastLink.addEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.blur */ .o5.blur, this.handleMobileLastItemBlur.bind(this));
        }
      }
    }
  }, {
    key: "handleMobileLastItemBlur",
    value: function handleMobileLastItemBlur(event) {
      if (this.firstLink) {
        event.preventDefault();
        event.stopPropagation();
        this.firstLink.focus();
      }
    }
  }, {
    key: "toggleScroll",
    value: function toggleScroll() {
      if (this.state.isMainMenuOpen || this.state.currentSubNav !== this._closedSubNavState) {
        document.body.classList.add('noScroll');
        document.body.style.top = "-".concat(this.state.lastScroll, "px");
        document.body.style.height = "-".concat(this.state.lastScroll, "px");
      } else {
        document.body.classList.remove('noScroll');
        document.body.style.top = null;
        document.body.style.height = null;
        window.scrollTo(0, this.state.lastScroll);
      }
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.insideMenuRef.current) {
        if (!this.insideMenuRef.current.contains(event.target)) {
          this.setState({
            currentSubNav: this._closedSubNavState
          });
        }
      }
    }
  }, {
    key: "handleToggleSubNavigation",
    value: function handleToggleSubNavigation(event) {
      var _this3 = this;

      var targetElemId = event.currentTarget.dataset.childId;

      if (targetElemId) {
        if (this.state.currentSubNav === targetElemId) {
          this.setState({
            currentSubNav: this._closedSubNavState,
            isLoadSubNav: true
          }, this.toggleScroll);
        } else {
          this.setState({
            currentSubNav: targetElemId,
            isLoadSubNav: true
          }, function () {
            _this3.toggleScroll();

            var subNav = _this3.subMenuRef.current;

            if (subNav) {
              var announcementBar = document.querySelector('.ob-announcement-bar');

              if (announcementBar && announcementBar.style.display !== 'none') {
                subNav.style.height = "calc(".concat(window.innerHeight, "px - ").concat(subNav.offsetTop + announcementBar.offsetHeight, "px)");
              } else {
                subNav.style.height = "calc(".concat(window.innerHeight, "px - ").concat(subNav.offsetTop, "px)");
              }
            }
          });
        }
      } else {
        this.setState({
          currentSubNav: this._closedSubNavState,
          isLoadSubNav: true
        }, this.toggleScroll);
      }
    }
  }, {
    key: "handleToggleMainMenu",
    value: function handleToggleMainMenu() {
      if (this.props.isLarge && !this.state.isMainMenuOpen) {
        this.addBlurListenerOnLastLink();
      }

      this.setState({
        isMainMenuOpen: !this.state.isMainMenuOpen,
        currentSubNav: this._closedSubNavState
      }, this.toggleScroll);
    }
  }, {
    key: "handleMenuHeight",
    value: function handleMenuHeight() {
      var innerMenu = document.querySelector('.ob-menu-collapsible');
      var announcementBar = document.querySelector('.ob-announcement-bar');
      document.body.classList.add('noScroll');

      if (innerMenu && innerMenu.style) {
        if (announcementBar && announcementBar.style.display !== 'none') {
          innerMenu.style.height = window.innerHeight - innerMenu.offsetTop + announcementBar.offsetHeight + 'px';
        } else {
          innerMenu.style.height = window.innerHeight - innerMenu.offsetTop + 'px';
        }
      }
    }
  }, {
    key: "renderCloseSubNavBtn",
    value: function renderCloseSubNavBtn() {
      var _this4 = this;

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("li", {
        className: "ob-main-menu__subNav--close-btn",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("button", {
          className: "event_close_window",
          onClick: function onClick(event) {
            _this4.handleToggleSubNavigation(event);
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react__WEBPACK_IMPORTED_MODULE_14__.Suspense, {
            fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_24__["default"], {}),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Icon, {
              name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.close */ .o5.close,
              size: 3,
              color: this.primaryColor
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
            className: "visuallyhidden",
            children: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.Close */ .o5.Close
          })]
        })
      });
    }
  }, {
    key: "renderHierarchyTitle",
    value: function renderHierarchyTitle(hierarchy, title) {
      var _this5 = this;

      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var toggleState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var level = _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__/* ["default"].getLevel */ .Z.getLevel(hierarchy);
      var childId = _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__/* ["default"].getHierarchyId */ .Z.getHierarchyId(hierarchy);
      var type = hierarchy.fields.type;

      if (level === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.child */ .o5.child && type !== _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.productByNeed */ .o5.productByNeed && type !== _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.productByType */ .o5.productByType && type !== _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.whyOralB */ .o5.whyOralB && type !== _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.conditions */ .o5.conditions && type !== _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.lifeStages */ .o5.lifeStages && type !== _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.ourAmbition */ .o5.ourAmbition) {
        var _hierarchy$fields, _hierarchy$fields2;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("button", {
          className: "event_menu_click ob-main-menu__subNav--btn link-button".concat(this.state.currentSubNav === childId || this.checkIfActive(hierarchy == null ? void 0 : (_hierarchy$fields = hierarchy.fields) == null ? void 0 : _hierarchy$fields.destinations) ? ' is-active' : ''),
          "data-action-detail": "".concat(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.Open */ .o5.Open, " ").concat((0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_18__/* .stripHtml */ .Vt)(title), " ").concat(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.panel */ .o5.panel),
          "aria-label": "".concat((0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_18__/* .stringToCapitalize */ .Sm)((0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_18__/* .stripHtml */ .Vt)(title)), " ").concat(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.pullDown */ .o5.pullDown, " ").concat(this.state.currentSubNav === childId ? _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.expanded */ .o5.expanded : _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.collapsed */ .o5.collapsed),
          "data-child-id": childId,
          onClick: function onClick(event) {
            _this5.handleToggleSubNavigation(event);
          },
          children: this.props.isLarge && hierarchy.fields.mainAsset ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react__WEBPACK_IMPORTED_MODULE_14__.Suspense, {
            fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_24__["default"], {}),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("span", {
              className: "ob-main-menu__subNav--btn-ctn",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
                className: "ob-main-menu__subNav--btn-img",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
                  image: hierarchy.fields.mainAsset
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
                className: "ob-main-menu__subNav--btn-content",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
                  className: "ob-main-menu__subNav--btn-title",
                  dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25___default().sanitize(title)
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
                  className: "ob-main-menu__subNav--btn-icon",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Icon, {
                    name: "chevronRight",
                    size: "1.3",
                    color: this.primaryColor
                  })
                })]
              })]
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react__WEBPACK_IMPORTED_MODULE_14__.Suspense, {
            fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_24__["default"], {}),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("span", {
              children: [this.state.currentSubNav === childId || this.checkIfActive(hierarchy == null ? void 0 : (_hierarchy$fields2 = hierarchy.fields) == null ? void 0 : _hierarchy$fields2.destinations) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
                "aria-current": 'page',
                className: "ob-main-menu__subNav--btn-title",
                dangerouslySetInnerHTML: {
                  __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25___default().sanitize(title)
                }
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
                className: "ob-main-menu__subNav--btn-title",
                dangerouslySetInnerHTML: {
                  __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25___default().sanitize(title)
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
                className: "ob-main-menu__subNav--btn-icon",
                children: this.props.isLarge ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Icon, {
                  name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.wideChevronDown */ .o5.wideChevronDown,
                  size: "0.8",
                  rotate: -90,
                  color: "#3D3D41"
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Icon, {
                  name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.chevronDown */ .o5.chevronDown,
                  size: "1.3",
                  rotate: 90,
                  color: this.primaryColor
                })
              })]
            })
          })
        });
      } else {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react__WEBPACK_IMPORTED_MODULE_14__.Suspense, {
          fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_24__["default"], {}),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("h2", {
              className: "ob-sub-navigation__title ob-sub-navigation__title--desktop",
              tabIndex: 0,
              dangerouslySetInnerHTML: {
                __html: title
              }
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("button", {
              "aria-expanded": (toggleState == null ? void 0 : toggleState.toLowerCase()) === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.expanding */ .o5.expanding || (toggleState == null ? void 0 : toggleState.toLowerCase()) === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.expanded */ .o5.expanded ? true : false,
              onClick: callback,
              className: "ob-sub-navigation__title ob-sub-navigation__title--mobile",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
                dangerouslySetInnerHTML: {
                  __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25___default().sanitize(title)
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
                children: (toggleState == null ? void 0 : toggleState.toLowerCase()) === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.expanding */ .o5.expanding || (toggleState == null ? void 0 : toggleState.toLowerCase()) === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.expanded */ .o5.expanded ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Icon, {
                  name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.minus6 */ .o5.minus6,
                  viewBox: 10,
                  size: "1",
                  color: "#000000"
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Icon, {
                  name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.plus */ .o5.plus,
                  viewBox: 10,
                  size: "1",
                  color: "#000000"
                })
              })]
            })]
          })
        });
      }
    }
  }, {
    key: "getHierarchyProperties",
    value: function getHierarchyProperties(hierarchy) {
      var destinations = hierarchy.fields.destinations;
      var title = hierarchy.fields.title;
      var hierarchyId = _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__/* ["default"].getHierarchyId */ .Z.getHierarchyId(hierarchy);
      var isSubNav = hierarchy.fields.type === 'product-by-need' || hierarchy.fields.type === 'product-by-type' || hierarchy.fields.type === 'why-oral-b' || hierarchy.fields.type === 'conditions' || hierarchy.fields.type === 'life-stages' || hierarchy.fields.type === 'our-ambition';
      var isMainMenu = hierarchyId === 'Hierarchy---Main-Menu';
      var isSubNavCtn = !isMainMenu && !isSubNav;
      var itemClassNames = !isSubNav ? 'ob-main-menu__list--item' : 'ob-sub-navigation--item';
      var mainMenuClassNames = isMainMenu ? 'ob-main-menu' : '';
      var subNavigationListClassNames = isSubNav ? 'ob-sub-navigation__list' : '';
      var iconPosition = null;
      var mainMenuListClassNames = isSubNavCtn ? 'ob-main-menu__subNav--ctn' : '';
      var listClassNames = "ob-main-menu__list ".concat(mainMenuListClassNames);
      var onlyShowOnClassNames = hierarchy.fields.onlyShowOn ? "ob-main-menu__list--".concat(hierarchy.fields.onlyShowOn) : '';

      if (isSubNavCtn) {
        itemClassNames = ' ob-sub-navigation';
        iconPosition = 'after';
      }

      return {
        destinations: destinations,
        title: title,
        hierarchyId: hierarchyId,
        isSubNav: isSubNav,
        isMainMenu: isMainMenu,
        isSubNavCtn: isSubNavCtn,
        itemClassNames: itemClassNames,
        mainMenuClassNames: mainMenuClassNames,
        subNavigationListClassNames: subNavigationListClassNames,
        iconPosition: iconPosition,
        mainMenuListClassNames: mainMenuListClassNames,
        listClassNames: listClassNames,
        onlyShowOnClassNames: onlyShowOnClassNames
      };
    }
  }, {
    key: "renderHierarchy",
    value: function renderHierarchy(hierarchy) {
      {
        return this.state.isPageLoaded ? this.props.isLarge || this.props.isLarge == null ? this.renderMobileHierarchy(hierarchy) : this.renderDesktopHierarchy(hierarchy) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)(react__WEBPACK_IMPORTED_MODULE_14__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
            className: "ob-main-menu__mobile__div",
            children: this.renderMobileHierarchy(hierarchy)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
            className: "ob-main-menu__desktop__div",
            children: this.renderDesktopHierarchy(hierarchy)
          })]
        });
      }
    }
  }, {
    key: "checkIfActive",
    value: function checkIfActive(menuItem) {
      var _this6 = this;

      var isActive = false;

      if (this.state.pathName !== '') {
        if (Array.isArray(menuItem)) {
          menuItem.forEach(function (destination) {
            var _destination$fields, _destination$fields3;

            if (destination == null ? void 0 : (_destination$fields = destination.fields) == null ? void 0 : _destination$fields.pagePath) {
              var _destination$fields2, _destination$fields2$, _destination$fields2$2;

              if ((destination == null ? void 0 : (_destination$fields2 = destination.fields) == null ? void 0 : (_destination$fields2$ = _destination$fields2.pagePath) == null ? void 0 : (_destination$fields2$2 = _destination$fields2$.fields) == null ? void 0 : _destination$fields2$2.slug) === _this6.state.pathName) {
                isActive = true;
              }
            } else if (destination == null ? void 0 : (_destination$fields3 = destination.fields) == null ? void 0 : _destination$fields3.destinations) {
              var _destination$fields4;

              destination == null ? void 0 : (_destination$fields4 = destination.fields) == null ? void 0 : _destination$fields4.destinations.forEach(function (elem) {
                var _elem$fields, _elem$fields$pagePath, _elem$fields$pagePath2;

                if ((elem == null ? void 0 : (_elem$fields = elem.fields) == null ? void 0 : (_elem$fields$pagePath = _elem$fields.pagePath) == null ? void 0 : (_elem$fields$pagePath2 = _elem$fields$pagePath.fields) == null ? void 0 : _elem$fields$pagePath2.slug) === _this6.state.pathName) {
                  isActive = true;
                }
              });
            }
          });
        } else {
          var _menuItem$fields, _menuItem$fields$page, _menuItem$fields$page2;

          if ((menuItem == null ? void 0 : (_menuItem$fields = menuItem.fields) == null ? void 0 : (_menuItem$fields$page = _menuItem$fields.pagePath) == null ? void 0 : (_menuItem$fields$page2 = _menuItem$fields$page.fields) == null ? void 0 : _menuItem$fields$page2.slug) === this.state.pathName) {
            isActive = true;
          }
        }
      }

      return isActive;
    }
  }, {
    key: "renderMobileHierarchy",
    value: function renderMobileHierarchy(hierarchy) {
      var _this7 = this;

      var properties = this.getHierarchyProperties(hierarchy);
      var closeMenuLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_20__.Label)({
        label: this.block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.closeMenuLabel */ .o5.closeMenuLabel)
      });
      var openMenuLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_20__.Label)({
        label: this.block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.openMenuLabel */ .o5.openMenuLabel)
      });
      var returnToMainMenuLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_20__.Label)({
        label: this.block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.returnToMainMenuLabel */ .o5.returnToMainMenuLabel)
      });
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
        className: 'ob-main-menu--mobile',
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)((react_slide_toggle__WEBPACK_IMPORTED_MODULE_22___default()), {
          duration: 500,
          collapsed: properties.isMainMenu && !this.state.isMainMenuOpen,
          ref: this.openMobileMenuRef,
          range: true,
          onExpanding: function onExpanding() {
            _this7.handleToggleMainMenu();
          },
          onCollapsing: function onCollapsing() {
            _this7.handleToggleMainMenu();
          },
          onExpanded: function onExpanded() {
            _this7.handleMenuHeight();
          },
          children: function children(_ref) {
            var onToggle = _ref.onToggle,
                setCollapsibleElement = _ref.setCollapsibleElement,
                range = _ref.range;
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
              ref: _this7.innerMenuRef,
              className: "".concat(properties.mainMenuClassNames, " ").concat(properties.onlyShowOnClassNames, " ").concat(properties.subNavigationListClassNames),
              children: [_this7.state.isMainMenuOpen && properties.isMainMenu && _this7.state.currentSubNav !== _this7._closedSubNavState && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("button", {
                className: 'ob-main-menu__return-btn',
                onClick: function onClick(event) {
                  _this7.handleToggleSubNavigation(event);
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Icon, {
                  name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.arrowLeft */ .o5.arrowLeft,
                  size: "2"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
                  className: 'visuallyhidden',
                  children: returnToMainMenuLabel
                })]
              }), properties.isMainMenu && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
                className: 'ob-main-menu__logo ob-main-menu__logo--mobile',
                children: _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__/* ["default"].renderDestination */ .Z.renderDestination(hierarchy.fields.destinations[0], _this7.renderHierarchy.bind(_this7, hierarchy.fields.destinations[0]))
              }), properties.isMainMenu && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
                className: 'ob-main-menu__open-ctn',
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("button", {
                  onClick: onToggle,
                  className: "event_menu_click",
                  "aria-expanded": _this7.state.isMainMenuOpen,
                  "data-action-detail": _this7.state.isMainMenuOpen ? closeMenuLabel : openMenuLabel,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("span", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Icon, {
                      name: _this7.state.isMainMenuOpen ? _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.close */ .o5.close : _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.hamburger */ .o5.hamburger,
                      size: "2",
                      color: _this7.primaryColor
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
                      className: 'visuallyhidden',
                      children: _this7.state.isMainMenuOpen ? closeMenuLabel : openMenuLabel
                    })]
                  })
                })
              }), properties.title && !properties.destinations && _this7.renderHierarchyTitle(hierarchy, properties.title), properties.destinations && !properties.isSubNav && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
                ref: setCollapsibleElement,
                className: 'ob-menu-collapsible',
                children: [properties.title && _this7.renderHierarchyTitle(hierarchy, properties.title), _this7.state.isPageLoaded ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
                  ref: properties.isMainMenu && _this7.mobileMenuRef,
                  children: _this7.state.isMainMenuOpen && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("ul", {
                    ref: properties.isSubNavCtn && _this7.state.currentSubNav === properties.hierarchyId && _this7.subMenuRef,
                    id: properties.hierarchyId,
                    className: "".concat(properties.listClassNames).concat(_this7.state.currentSubNav === properties.hierarchyId ? ' is-active' : ''),
                    style: range ? {
                      opacity: Math.max(0, range)
                    } : {
                      opacity: 1
                    },
                    children: _this7.state.isMainMenuOpen && _this7.renderDestination(properties, 'chevronRight')
                  })
                }) : null]
              }), properties.destinations && properties.isSubNav && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)((react_slide_toggle__WEBPACK_IMPORTED_MODULE_22___default()), {
                duration: 500,
                collapsed: properties.hierarchyId !== 'Hierarchy---More-Products---By-Type',
                children: function children(_ref2) {
                  var onToggle = _ref2.onToggle,
                      setCollapsibleElement = _ref2.setCollapsibleElement,
                      range = _ref2.range,
                      toggleState = _ref2.toggleState;
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
                    children: [properties.title && _this7.renderHierarchyTitle(hierarchy, properties.title, onToggle, toggleState), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("ul", {
                      className: 'ob-sub-navigation__list',
                      ref: setCollapsibleElement,
                      style: range ? {
                        opacity: Math.max(0, range)
                      } : {
                        opacity: 1
                      },
                      children: _this7.renderDestination(properties, 'chevronRight')
                    })]
                  });
                }
              })]
            });
          }
        })
      });
    }
  }, {
    key: "renderDesktopHierarchy",
    value: function renderDesktopHierarchy(hierarchy) {
      var _properties$destinati,
          _this8 = this;

      var properties = this.getHierarchyProperties(hierarchy);
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
        className: "".concat(properties.mainMenuClassNames, " ").concat(properties.onlyShowOnClassNames, " ").concat(properties.subNavigationListClassNames),
        children: [properties.title && !properties.destinations && this.renderHierarchyTitle(hierarchy, properties.title), properties.destinations && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
          className: properties.isMainMenu ? 'ob-main-menu__ctn' : '',
          children: [properties.isMainMenu && properties.destinations && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
            className: 'ob-main-menu__logo ob-main-menu__logo--desktop',
            children: _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__/* ["default"].renderDestination */ .Z.renderDestination(hierarchy.fields.destinations[0], this.renderHierarchy.bind(this, hierarchy.fields.destinations[0]))
          }), properties.title && this.renderHierarchyTitle(hierarchy, properties.title), properties.isMainMenu ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("ul", {
            ref: properties.isSubNavCtn && this.state.currentSubNav === properties.hierarchyId && this.subMenuRef,
            id: properties.hierarchyId,
            className: "".concat(properties.listClassNames).concat(this.state.currentSubNav === properties.hierarchyId ? ' is-active' : ''),
            children: [properties == null ? void 0 : (_properties$destinati = properties.destinations) == null ? void 0 : _properties$destinati.map(function (dest, index) {
              var _dest$fields, _dest$fields2, _dest$fields3, _dest$fields4, _dest$fields5, _dest$fields6, _dest$fields7, _dest$fields8;

              return (dest == null ? void 0 : (_dest$fields = dest.fields) == null ? void 0 : _dest$fields.contentType) !== 'languageSelectionBlock' && (dest == null ? void 0 : (_dest$fields2 = dest.fields) == null ? void 0 : _dest$fields2.contentType) !== 'loginNavigationBlock' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("li", {
                className: "".concat(properties.itemClassNames).concat((dest == null ? void 0 : (_dest$fields3 = dest.fields) == null ? void 0 : _dest$fields3.className) ? ' ' + (dest == null ? void 0 : (_dest$fields4 = dest.fields) == null ? void 0 : _dest$fields4.className) : '').concat(!(dest == null ? void 0 : (_dest$fields5 = dest.fields) == null ? void 0 : _dest$fields5.image) && !properties.isMainMenu ? ' no-img' : ''),
                "data-is-logo": properties.isMainMenu && index === 0,
                "data-is-language-selector": (dest == null ? void 0 : (_dest$fields6 = dest.fields) == null ? void 0 : _dest$fields6.contentType) === 'languageSelectionBlock',
                "data-is-login-navigation-block": (dest == null ? void 0 : (_dest$fields7 = dest.fields) == null ? void 0 : _dest$fields7.contentType) === 'loginNavigationBlock',
                children: (dest == null ? void 0 : (_dest$fields8 = dest.fields) == null ? void 0 : _dest$fields8.image) && !properties.isMainMenu ? _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__/* ["default"].renderDestination */ .Z.renderDestination(dest, _this8.renderHierarchy.bind(_this8, dest), {
                  name: 'ovalArrowRight',
                  position: 'before'
                }) : _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__/* ["default"].renderDestination */ .Z.renderDestination(dest, _this8.renderHierarchy.bind(_this8, dest), null, null, _this8.checkIfActive(dest) ? ' is-active' : null)
              }, index);
            }), properties.isSubNavCtn && this.state.currentSubNav === properties.hierarchyId && this.renderCloseSubNavBtn()]
          }) : this.state.isLoadSubNav ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
            className: "".concat(properties.listClassNames, " ").concat(this.state.currentSubNav === properties.hierarchyId ? 'is-active' : ''),
            ref: properties.isSubNavCtn && this.state.currentSubNav === properties.hierarchyId && this.subMenuRef,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("ul", {
              id: properties.hierarchyId,
              className: "ob-main-menu__subNav-list ".concat(this.state.currentSubNav === properties.hierarchyId ? ' is-active' : '', "\n                                            ").concat(properties.destinations.length === 3 ? 'ob-learn-section-length-3' : 'ob-learn-section-length-4'),
              children: [properties.destinations.map(function (dest, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("li", {
                  className: "".concat(properties.itemClassNames).concat(dest.fields.className ? ' ' + dest.fields.className : '').concat(!dest.fields.image && !properties.isMainMenu ? ' no-img' : ''),
                  "data-is-logo": properties.isMainMenu && index === 0,
                  "data-is-language-selector": dest.fields.contentType === 'languageSelectionBlock',
                  "data-is-login-navigation-block": dest.fields.contentType === 'loginNavigationBlock',
                  children: dest.fields.image && !properties.isMainMenu ? _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__/* ["default"].renderDestination */ .Z.renderDestination(dest, _this8.renderHierarchy.bind(_this8, dest), {
                    name: 'ovalArrowRight',
                    position: 'before'
                  }) : _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__/* ["default"].renderDestination */ .Z.renderDestination(dest, _this8.renderHierarchy.bind(_this8, dest))
                }, index);
              }), properties.isSubNavCtn && this.state.currentSubNav === properties.hierarchyId && this.renderCloseSubNavBtn()]
            })
          }) : null]
        })]
      });
    }
  }, {
    key: "renderDestination",
    value: function renderDestination(properties) {
      var _this9 = this;

      var iconName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var icon = {
        name: iconName,
        position: properties.iconPosition
      };
      return properties.destinations.map(function (dest, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("li", {
          className: "".concat(properties.itemClassNames).concat(dest.fields.className ? ' ' + dest.fields.className : '').concat(!dest.fields.image && !dest.fields.mainAsset ? ' no-img' : '').concat(dest.fields.contentType === 'loginNavigationBlock' ? ' ob-main-menu__login-navigation' : ''),
          "data-is-logo": properties.isMainMenu && index === 0,
          children: _adapters_helpers_HierarchyUtils__WEBPACK_IMPORTED_MODULE_23__/* ["default"].renderDestination */ .Z.renderDestination(dest, _this9.renderHierarchy.bind(_this9, dest), icon)
        }, index);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = "main-menu ".concat(this.block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.classNames */ .o5.classNames) !== undefined ? this.block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.classNames */ .o5.classNames) : '');
      var hierarchyDoc = this.block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.hierarchy */ .o5.hierarchy);
      var hierarchyImage = hierarchyDoc.fields.mainAsset;
      var mainMenuLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_20__.Label)({
        label: this.block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .MainMenuConstants.mainMenuLabel */ .o5.mainMenuLabel)
      });
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("nav", {
        "aria-label": mainMenuLabel,
        ref: this.insideMenuRef,
        role: "navigation",
        className: "".concat(className, " ").concat(this.state.isMainMenuOpen ? 'is-active' : ''),
        children: [this.renderHierarchy(hierarchyDoc), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react__WEBPACK_IMPORTED_MODULE_14__.Suspense, {
          fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_24__["default"], {}),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
            image: hierarchyImage
          })
        })]
      });
    }
  }]);

  return MainMenu;
}(react__WEBPACK_IMPORTED_MODULE_14__.Component);

/* harmony default export */ __webpack_exports__["default"] = ((0,_adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_21__/* .mediaQueryHOC */ .Ui)(MainMenu)); // This export is for unit testing (do not remove) :

var MainMenuTest = MainMenu;

/***/ })

}]);